<template>
    <div class="lms__user_account_security_password">
        <component-title :size="'tiny'">{{ $t('lms.user.account.security.title.text') }}</component-title>
        <template v-if="!activeForm">
            <component-button
                :size="'full'"
                :align="'left'"
                :theme="'default'"
                :name="'lms-user-account-security-password-change'"
                :disabled="user.isInpersonated()"
                @click="switchActiveForm"
            >{{ $t('auth.twoFactorAuth.buttons.changePassword') }}
            </component-button>
        </template>
        <template v-else>
            <div class="lms__user_account_security_password_box">
                <form-text
                    :password="true"
                    :name="'current-password'"
                    :label="$t('lms.user.account.security.labels.currentPassword')"
                    :required="true"
                    :v-validate="{ required: true, regex: passwordRegex }"
                    :data-vv-as="$t('forms.dataVvAs.currentPassword')"
                    v-model="oldPassword"
                />
                <form-text
                    :password="true"
                    :name="'new-password'"
                    :label="$t('lms.user.account.security.labels.newPassword')"
                    :required="true"
                    :v-validate="{ required: true, regex: passwordRegex }"
                    :data-vv-as="$t('forms.dataVvAs.newPassword')"
                    v-model="newPassword"
                >Password length must be at least 8 and includes:<br>- lowercase letter<br>- uppercase letter<br>- special character<br>- number</form-text>
                <form-text
                    :password="true"
                    :name="'confirm-password'"
                    :label="$t('lms.user.account.security.labels.confirmPassword')"
                    :required="true"
                    :v-validate="{ required: true, regex: passwordRegex, is: newPassword }"
                    :data-vv-as="$t('forms.dataVvAs.confirmPassword')"
                    v-model="newPasswordConfirm"
                />
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :theme="'default'"
                            @click="switchActiveForm"
                            :name="'lms-user-account-security-password-cancel'"
                        >{{ $t('auth.twoFactorAuth.buttons.cancel') }}
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            @click="openNotifyChangePassword"
                            :name="'lms-user-account-security-password-save'"
                        >{{ $t('auth.twoFactorAuth.buttons.savePassword') }}
                        </component-button>
                    </div>
                </div>
                <pop-notify
                    ref="popnotifychangepassword"
                    :class="'pop__notify--changepassword'"
                    :title-text="$t('lms.user.account.security.notify.changePassword')"
                    :content-text="$t('lms.user.account.security.notify.contentPassword')"
                    :cancel-button-text="$t(`lms.user.account.security.notify.cancelButtonText`)"
                    :submit-button-text="$t(`lms.user.account.security.notify.confirmButtonText`)"
                    :submit-button-animate-loading="true"
                    :prevent-close="true"
                    @emit-submit="performChangePassword"
                />
            </div>
        </template>
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import FormText from '@/components/default/forms/FormText'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { passwordRegex } from '@/variables'
import { User } from '@/User'

export default {
  name: 'lms-user-account-security-password',
  components: { ComponentButton, FormText, PopNotify, ComponentTitle },
  data () {
    return {
      activeForm: false,
      user: new User(),
      passwordRegex
    }
  },
  computed: {
    oldPassword: {
      get () {
        return this.$store.getters.getLmsUserAccountSecurityOldPassword
      },
      set (value) {
        this.$store.dispatch('lmsUserAccountSetSecurityOldPassword', value)
      }
    },
    newPassword: {
      get () {
        return this.$store.getters.getLmsUserAccountSecurityNewPassword
      },
      set (value) {
        this.$store.dispatch('lmsUserAccountSetSecurityNewPassword', value)
      }
    },
    newPasswordConfirm: {
      get () {
        return this.$store.getters.getLmsUserAccountSecurityConfirmNewPassword
      },
      set (value) {
        this.$store.dispatch('lmsUserAccountSetSecurityConfirmNewPassword', value)
      }
    },
    watchContent () {
      return this.oldPassword + this.newPassword + this.newPasswordConfirm
    },
    //
    rootItemName () {
      return 'account-security'
    }
  },
  methods: {
    switchActiveForm () {
      this.activeForm = !this.activeForm
      this.$store.dispatch('lmsUserAccountSecurityClear')
    },
    openNotifyChangePassword () {
      this.$validator.resume()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$refs.popnotifychangepassword.openNotify()
        }
      })
    },
    performChangePassword () {
      this.$validator.resume()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch(`lmsUserAccountSecurityUpdate`).then(() => {
            this.switchActiveForm()
            this.$eventBus.$emit('stop-sending')
          })
        } else {
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    }
  },
  mounted () {
    this.$validator.pause()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/account/_lmsuseraccountsecuritypassword.scss";
</style>
